import { Deposits, Transaction, User } from '@repo/database/src/types';

export type DepositWithRelations = Deposits & {
  user: Pick<User, 'id' | 'alias' | 'email'>;
  inboundTx: Transaction;
  outboundTx?: Transaction | null;
};

export class DepositsResponseDto {
  deposits: DepositWithRelations[];
  totalCount: number;
}
